import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LOCAL_STORAGE } from 'constants/appConstants';
import { APP_ROUTES } from 'constants/routeConstants';
import { getLocalStorageItem } from 'utils/localStorage';

// External/Public routes where chatbot should be hidden
const EXTERNAL_ROUTES = [
  APP_ROUTES.ROOT,
  APP_ROUTES.LOGIN,
  APP_ROUTES.REGISTER,
  APP_ROUTES.FORGOT_PASSWORD,
  APP_ROUTES.RESET_PASSWORD,
  APP_ROUTES.OTP_VERIFICATION,
];

const CHATBOT_CONTAINER_ID = '#teleperson-iframe';

export const useChatbotVisibility = () => {
  const location = useLocation();

  useEffect(() => {
    const manageChatbotVisibility = () => {
      // Get authentication status
      const { token: isAuthenticated = '' } =
        getLocalStorageItem(LOCAL_STORAGE.USER_DETAILS) || {};

      // Check if current route is external
      const isExternalRoute = EXTERNAL_ROUTES.includes(location.pathname);

      // Determine if chatbot should be visible
      const shouldShowChatbot = isAuthenticated && !isExternalRoute;

      // Wait for chatbot to load then manage visibility
      const manageChatbot = () => {
        const chatbotContainer = document.querySelector(
          CHATBOT_CONTAINER_ID,
        ) as HTMLElement;

        if (chatbotContainer) {
          if (shouldShowChatbot) {
            chatbotContainer.style.display = 'block';
            console.log('Chatbot shown');
          } else {
            chatbotContainer.style.display = 'none';
            console.log('Chatbot hidden');
          }
        } else {
          // If chatbot not loaded yet, try again after a short delay
          setTimeout(manageChatbot, 500);
        }
      };

      // Initial check
      manageChatbot();

      // Also check after a delay to handle late-loading chatbot
      setTimeout(manageChatbot, 1000);
    };

    manageChatbotVisibility();
  }, [location.pathname]);

  return {
    isExternalRoute: EXTERNAL_ROUTES.includes(location.pathname),
  };
};
